import { trpc } from '@/utils/trpc.ts'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { router } from '../App.tsx'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const UseInvalidateRouter = () => {
  const utils = trpc.useUtils()
  const invalidateRouter = () => {
    router.invalidate()
    utils.invalidate()
  }

  return { invalidateRouter }
}

export function isSafariBrowser() {
  const ua = navigator.userAgent
  const isSafari = ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium')
  return isSafari
}

export const capitalizeCardType = (str: string) => str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
